import { tv } from 'tailwind-variants';

const trackStyles = `
  iris:w-full
  iris:h-(--comp-size-border-step-indicator-track-mobile)
  iris:flex-1 iris:basis-0
  iris:border-solid
  iris:border-(length:--comp-size-border-step-indicator-track-mobile) iris:md:border-(length:--comp-size-border-step-indicator-track-desktop)
  iris:border-(--comp-color-border-step-indicator-track)
`;
const stepStyles = tv({
    slots: {
        checkMiniIcon: `
      iris:size-(--comp-size-icon-step-indicator-mobile) iris:fill-(--comp-color-content-step-indicator-icon-complete)
      iris:md:size-(--comp-size-icon-step-indicator-desktop)
    `,
        interactiveOverlay: `
      iris:absolute
      iris:inset-0
      iris:right-1/4
      iris:left-1/4
      iris:cursor-pointer
      iris:focus-visible:rounded-xs
      iris:focus-visible:ring-2
      iris:focus-visible:ring-(--sem-color-border-interactive-selected)
      iris:focus-visible:ring-offset-2
      iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
      iris:focus-visible:outline-none
    `,
        listContainer: `
      iris:min-w-0 
      iris:flex-1
    `,
        stepContainer: `
      iris:@container
      iris:relative
      iris:flex
      iris:min-w-full
      iris:flex-col
      iris:items-center
      iris:gap-(--comp-space-gap-step-indicator)
      iris:p-(--base-space-px-0)
      iris:focus-visible:outline-none
    `,
        circleLineContainer: `
      iris:flex
      iris:items-center
      iris:justify-end
      iris:self-stretch
    `,
        circleNumber: `
      iris:flex
      iris:size-(--comp-size-box-step-indicator-mobile)
      iris:items-center
      iris:justify-center 
      iris:gap-[6px]
      iris:rounded-(--comp-size-radius-step-indicator)
      iris:border-(length:--comp-size-border-step-indicator-circle-mobile)
      iris:border-solid
      iris:border-(--comp-color-border-step-indicator-circle-active) iris:bg-(--comp-color-background-step-indicator-active)
      iris:md:size-(--comp-size-box-step-indicator-desktop)
      iris:md:border-(length:--comp-size-border-step-indicator-circle-desktop)
    `,
        leftTrack: trackStyles,
        rightTrack: trackStyles,
        number: `
      iris:text-center
      iris:font-(family-name:--comp-type-font-step-indicator)
      iris:text-(length:--comp-type-size-step-indicator-mobile)
      iris:leading-(--base-type-leading-none) 
      iris:font-(--comp-type-weight-step-indicator-number)!
      iris:tracking-(--comp-type-tracking-step-indicator)
      iris:text-(--comp-color-content-step-indicator-number-active)
      iris:not-italic
      iris:md:text-(length:--comp-type-size-step-indicator-desktop)
    `,
        labelContainer: `
      iris:@container
      iris:flex
      iris:items-center iris:justify-center
      iris:gap-(--base-space-px-8)
      iris:self-stretch
      iris:p-0
      iris:px-4
    `,
        label: `
      iris:hidden iris:flex-1
      iris:basis-0
      iris:justify-center iris:text-center
      iris:font-(family-name:--comp-type-font-step-indicator)
      iris:text-(length:--comp-type-size-step-indicator-mobile)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-step-indicator-label)!
      iris:tracking-(--comp-type-tracking-step-indicator)
      iris:text-(--comp-color-content-step-indicator-label-active)
      iris:not-italic
      iris:md:text-(length:--comp-type-size-step-indicator-desktop)
      iris:@min-[75cqw]:block
    `,
    },
    variants: {
        inverse: {
            true: "",
            false: "",
        },
        stepState: {
            complete: "",
            disabled: "",
            active: "",
            visited: "",
        },
        stepLocation: {
            start: {
                leftTrack: "iris:opacity-0",
                rightTrack: "iris:opacity-100",
            },
            middle: {
                leftTrack: "iris:opacity-100",
                rightTrack: "iris:opacity-100",
            },
            end: {
                leftTrack: "iris:opacity-100",
                rightTrack: "iris:opacity-0",
            },
        },
    },
    compoundVariants: [
        {
            inverse: false,
            stepState: "active",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-active)
          iris:bg-(--comp-color-background-step-indicator-active)
        `,
                leftTrack: "iris:border-(--comp-color-border-step-indicator-track-complete)",
                number: "iris:text-(--comp-color-content-step-indicator-number-active)",
                label: "iris:text-(--comp-color-content-step-indicator-label-active)",
            },
        },
        {
            inverse: false,
            stepState: "complete",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-complete)
          iris:bg-(--comp-color-background-step-indicator-complete)
        `,
                leftTrack: "iris:border-(--comp-color-border-step-indicator-track-complete)",
                rightTrack: "iris:border-(--comp-color-border-step-indicator-track-complete)",
                label: "iris:text-(--comp-color-content-step-indicator-label-complete)",
            },
        },
        {
            inverse: false,
            stepState: "disabled",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-disabled)
          iris:bg-(--comp-color-background-step-indicator-disabled)
        `,
                number: `
          iris:font-(--comp-type-weight-step-indicator-number-disabled)!
          iris:text-(--comp-color-content-step-indicator-number-disabled)
        `,
                label: "iris:text-(--comp-color-content-step-indicator-label-disabled)",
            },
        },
        {
            inverse: false,
            stepState: "visited",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-visited)
          iris:bg-(--comp-color-background-step-indicator-visited)
        `,
                number: "iris:text-(--comp-color-content-step-indicator-number-visited)",
                label: "iris:text-(--comp-color-content-step-indicator-label-visited)",
            },
        },
        {
            inverse: true,
            stepState: "active",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-inverse-active)
          iris:bg-(--comp-color-background-step-indicator-inverse-active)
        `,
                number: "iris:text-(--comp-color-content-step-indicator-number-inverse-active)",
                leftTrack: "iris:border-(--comp-color-border-step-indicator-track-complete-inverse)",
                rightTrack: "iris:border-(--comp-color-border-step-indicator-track-inverse)",
                label: "iris:text-(--comp-color-content-step-indicator-label-inverse-active)",
            },
        },
        {
            inverse: true,
            stepState: "complete",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-inverse-complete)
          iris:bg-(--comp-color-background-step-indicator-inverse-complete)
        `,
                leftTrack: "iris:border-(--comp-color-border-step-indicator-track-complete-inverse)",
                rightTrack: "iris:border-(--comp-color-border-step-indicator-track-complete-inverse)",
                checkMiniIcon: `
          iris:border(--comp-color-border-step-indicator-circle-inverse-complete)
          iris:fill-(--comp-color-content-step-indicator-icon-inverse-complete)
        `,
                label: "iris:text-(--comp-color-content-step-indicator-label-inverse-complete)",
            },
        },
        {
            inverse: true,
            stepState: "disabled",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-inverse-disabled)
          iris:bg-(--comp-color-background-step-indicator-inverse-disabled)
        `,
                number: `
          iris:font-(--comp-type-weight-step-indicator-number-disabled)!
          iris:text-(--comp-color-content-step-indicator-number-inverse-disabled)
        `,
                leftTrack: "iris:border-(--comp-color-border-step-indicator-track-inverse)",
                rightTrack: "iris:border-(--comp-color-border-step-indicator-track-inverse)",
                label: "iris:text-(--comp-color-content-step-indicator-label-inverse-disabled)",
            },
        },
        {
            inverse: true,
            stepState: "visited",
            class: {
                circleNumber: `
          iris:border-(--comp-color-border-step-indicator-circle-inverse-visited)
          iris:bg-(--comp-color-background-step-indicator-inverse-visited)
        `,
                number: "iris:text-(--comp-color-content-step-indicator-number-inverse-visited)",
                leftTrack: "iris:border-(--comp-color-border-step-indicator-track-inverse)",
                rightTrack: "iris:border-(--comp-color-border-step-indicator-track-inverse)",
                label: "iris:text-(--comp-color-content-step-indicator-label-inverse-visited)",
            },
        },
    ],
});

export { stepStyles as default };
